import React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import AuthService from '../../../services/auth.service';
import { Alert } from '../../../services/notiflix.service';
import { useEffect, useRef, useState } from 'react';
import AuthCommonButton from '../../../components/common/auth/AuthCommonButton';
import AuthRootComponent from '../../../components/common/auth/AuthRootComponent';
import AuthHeaderTextComponent from '../../../components/common/auth/AuthHeaderTextComponent';
import TurnstileWidget from '../../../components/common/auth/TurnstileWidget';
import { useTranslation } from 'react-i18next';
import i18n from '../../../utils/i18n';
import { useSelector } from 'react-redux';
import configService from '../../../services/config.service';
const ForgotPassword = () => {
  const [isLoader, setLoader] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const turnstileRef = useRef(null);
  const turnstileEnabled = !!configService.turnstileSiteKey();
  const { t } = useTranslation(['profile', 'common', 'auth']);
  const language = useSelector((state) => state.languageReducer.language);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  const schema = Yup.object({
    email: Yup.string()
      .required(t('auth:email_required'))
      .email(t('auth:email_invalid')),
  }).required();
  // Turnstile tokens are single-use, so request a fresh one after every submit.
  const resetTurnstile = () => {
    setTurnstileToken(null);
    turnstileRef.current?.reset();
  };
  const onForgotPassword = async (_input) => {
    try {
      if (turnstileEnabled && !turnstileToken) {
        Alert.error(t('auth:captcha_required'));
        return false;
      }
      setLoader(true);
      const _forgotPasswordData = {
        email: _input.email,
        'cf-turnstile-response': turnstileToken,
      };

      let response = await AuthService.ForgotPassword(_forgotPasswordData);
      if (response.status === 'failure') {
        setLoader(false);
        resetTurnstile();
        Alert.error(response.message);
        return false;
      }

      setLoader(false);
      reset();
      resetTurnstile();
      Alert.success(response.message);
    } catch (error) {
      setLoader(false);
      resetTurnstile();
      Alert.error(error.message);
      return false;
    }
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <>
      <AuthRootComponent>
        <div className="w-full md:w-96 bg-white dark:bg-slate-800 dark:text-slate-200 px-6 py-10 rounded-md m-6">
          <AuthHeaderTextComponent
            title={t('auth:forget_password')}
            desc={t('auth:reset_password_instruction', {
              appName: configService.appName(),
            })}
          />
          <form onSubmit={handleSubmit(onForgotPassword)}>
            <input
              placeholder={t('common:email_address')}
              type="text"
              {...register('email', { required: true })}
              className="mb-6"
            />
            <div className="common-error-text">{errors.email?.message}</div>
            <TurnstileWidget
              ref={turnstileRef}
              onVerify={setTurnstileToken}
              onExpire={() => setTurnstileToken(null)}
            />
            <div className="mt-4">
              <AuthCommonButton
                isLoader={isLoader}
                Title={t('auth:send_reset_link')}
                isDisabled={turnstileEnabled && !turnstileToken}
              />
            </div>
          </form>

          <div className="my-3 text-center">
            <Link
              to="/login"
              className={`text-[#3D4CB2] dark:text-GreenColor text-center inline-block ${isLoader ? 'pointer-events-none text-gray-400' : ''}`}
            >
              Login
            </Link>
          </div>
        </div>
      </AuthRootComponent>
    </>
  );
};

export default ForgotPassword;
